// extracted by mini-css-extract-plugin
module.exports = {"actions":"expense-actions_actions__Zqk6_"};